import type { User } from "@dndbeyond/auth/types/user";
import { createContext } from "react";

export const Context = createContext<{
  worker?: Worker;
  nodeEnv?: string;
  env?: string;
  user?: User;
  hasWorkerErrored: boolean;
  isWorkerReady: boolean;
}>({
  hasWorkerErrored: false,
  isWorkerReady: false,
});
